import styled from 'styled-components';

export const ImportModalContainer = styled.div`
  .es-modal {
    width: 600px;
  }

  .es-modal-header {
    font-size: 22px;
    line-height: 30px;
  }
`;
